import React from 'react';
import { Typography, Button, Divider } from '@material-ui/core';
import { Radio, RadioGroup, FormControlLabel, FormControl } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

function SecondStep(props) {
    const { values } = props;
    var clickCount = 0;
    const next = (event) => {
        event.preventDefault();
        props.handleChange(event);
        clickCount++;
        if (clickCount < 2) {
            setTimeout(() => {
                if (clickCount <= 1) {
                    props.nextStep();
                }
                clickCount = 0;
            }, 200);
        }
    }
    const back = (event) => {
        event.preventDefault();
        clickCount++;
        if (clickCount < 2) {
            setTimeout(() => {
                if (clickCount <= 1) {
                    props.prevStep();
                }
                clickCount = 0;
            }, 200);
        }
    }
    return (
        <React.Fragment>
            <Typography variant="h6" component="h6" className="navi-title">
                桁種は？
            </Typography>
            <div className="navi-description">
                <FormControl component="fieldset">
                    <RadioGroup className="navi-radio" aria-label="ketashuKubun" name="ketashuKubun" value={values.chartParam.ketashuKubun}>
                        <FormControlLabel value="" control={<Radio color="primary" onClick={next} />} label="指定しない" className="navi-radio-label" />
                        <FormControlLabel value="1" control={<Radio color="primary" onClick={next} />} label="鋼橋" className="navi-radio-label" />
                        <FormControlLabel value="2" control={<Radio color="primary" onClick={next} />} label="コンクリート橋" className="navi-radio-label" />
                    </RadioGroup>
                </FormControl>
            </div>
            <Divider className="navi-divider" />
            <div className="navi-paging">
                <Button size="large" color="primary" onClick={back} startIcon={<ArrowBackIcon />}>戻る</Button>
            </div>
        </React.Fragment>
    )
}

export default SecondStep;
